import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_SAVE_ASSET_INVENTORY, GET_VALIDATE_ASSET_INVENTORY_RESET } from 'Store/AssetInventory/AssetInventoryReset/AssetInventoryResetTypes';
import { setSaveAssetInventoryReset, setValidateAssetInventory } from 'Store/AssetInventory/AssetInventoryReset/AssetInventoryResetAction';


function* resetAssetInventoryValidationSaga(): any {
    try {
        yield put(globalLoaderText("Validating...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `validate/assessment/reset`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setValidateAssetInventory(response))
        }
    } catch (error) {
        console.log(error);
        yield put(setValidateAssetInventory({ error: true }))
        yield put(globalLoaderText(""));
    }
}

function* saveAssetInventoryReset(req: any): any {
    try {
        yield put(globalLoaderText("Resetting Asset Inventory...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `inventory/assessment/reset`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );


        yield put(globalLoaderText(""));
        yield put(setSaveAssetInventoryReset(response))
    } catch (error) {
        console.log(error);
        yield put(setSaveAssetInventoryReset(false))
        yield put(globalLoaderText(""));
    }
}

function* watchGetAllAssements() {
    yield takeEvery(GET_VALIDATE_ASSET_INVENTORY_RESET, resetAssetInventoryValidationSaga)
    yield takeEvery(GET_SAVE_ASSET_INVENTORY, saveAssetInventoryReset)
}

export default function* combinedSaga() {
    yield all([
        watchGetAllAssements()
    ])
}